var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 18 18",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M12.7632 6.86623C13.0756 6.55388 13.0756 6.04662 12.7632 5.73427C12.4509 5.42191 11.9436 5.42191 11.6313 5.73427L9 8.36803L6.36623 5.73676C6.05388 5.42441 5.54662 5.42441 5.23427 5.73676C4.92191 6.04912 4.92191 6.55638 5.23427 6.86873L7.86803 9.5L5.23676 12.1338C4.92441 12.4461 4.92441 12.9534 5.23676 13.2657C5.54912 13.5781 6.05638 13.5781 6.36873 13.2657L9 10.632L11.6338 13.2632C11.9461 13.5756 12.4534 13.5756 12.7657 13.2632C13.0781 12.9509 13.0781 12.4436 12.7657 12.1313L10.132 9.5L12.7632 6.86623Z",
          fill: "#A8AEB8",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }